import { useEffect, useRef } from 'react';
import { subscribeAcraSyncRealtime } from '../lib/acraSyncRealtimeHub';

const DEFAULT_DEBOUNCE_MS = 4000;

type UseAcraSyncRealtimeOptions = {
  enabled?: boolean;
  debounceMs?: number;
  /** Only fire when sync finishes or fails — avoids hammering the list during long runs. */
  onlyOnComplete?: boolean;
};

/**
 * Fires when crm.acra_entities_sync_state changes (nightly sync progress / completion).
 * Uses one shared Realtime channel for the whole app (multiple hooks must not each subscribe).
 */
export function useAcraSyncRealtime(
  onChange: () => void,
  options: UseAcraSyncRealtimeOptions = {},
) {
  const { enabled = true, debounceMs = DEFAULT_DEBOUNCE_MS, onlyOnComplete = false } = options;
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!enabled) return undefined;
    return subscribeAcraSyncRealtime(() => onChangeRef.current(), { onlyOnComplete, debounceMs });
  }, [enabled, debounceMs, onlyOnComplete]);
}
